import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fun-overview-status-skeleton',
  templateUrl: './overview-status-skeleton.component.html',
  styleUrls: ['./overview-status-skeleton.component.scss'],
})
export class OverviewStatusSkeletonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
